/** Site survey answers and their one-line summary, without the Api client (tests import this). */
export type SurveyChoice = 'yes' | 'no' | 'unsure';
export interface SurveyAnswers {
  chargers_wanted: number | null; parking_spaces: number | null; mounting: 'wall' | 'pedestal' | 'unsure' | null; panel_amps: number | null;
  spare_capacity: SurveyChoice | null; load_study: SurveyChoice | null; run_ft: number | null; trenching: SurveyChoice | null;
  cell_signal: 'good' | 'weak' | 'none' | 'unsure' | null; wifi_at_spot: SurveyChoice | null;
}
/** One line for a list: the answers that size the job. */
export function surveySummary(a: SurveyAnswers) {
  return [a.chargers_wanted != null ? `${a.chargers_wanted} charger${a.chargers_wanted === 1 ? '' : 's'}` : null, a.mounting && a.mounting !== 'unsure' ? a.mounting : null,
    a.panel_amps != null ? `${a.panel_amps} A panel` : null, a.run_ft != null ? `${a.run_ft} ft run` : null,
    a.cell_signal && a.cell_signal !== 'unsure' ? `${a.cell_signal} signal` : null].filter(Boolean).join(' · ');
}
